export default "__VITE_ASSET__CcoFGThZ__"